import { MOBILE_SCREEN_WIDTH } from '../../../../../constants/common/screen.js';
import { getColorsFromCreatorTheme } from '../../../../../features/Common/modules/Theme/utils/Theme.utils.js';
import { getStylesObjFromCss } from '../../../../../utils/common/styling.js';

var _a, _b, _c;
var styles = getStylesObjFromCss({
    styles: {
        moreButton: {
            cursor: "pointer",
        },
        moreMenuContainer: (_a = {
                display: "flex",
                flexDirection: "column",
                background: "#E7E6E4",
                gap: 1,
                "& button": {
                    background: "white",
                    borderRadius: 0,
                    textAlign: "start",
                    textTransform: "none",
                    justifyContent: "flex-start",
                    fontSize: "1rem",
                    fontWeight: "normal",
                    color: "#272522",
                    padding: "8px 16px",
                }
            },
            _a["@media(max-width: ".concat(MOBILE_SCREEN_WIDTH, "px)")] = {
                minHeight: 60,
                background: "white",
                display: "block",
                "& button": {
                    padding: "8px 16px",
                },
            },
            _a),
        divider: (_b = {
                height: 1,
                background: "#E7E6E4",
                display: "none"
            },
            _b["@media(max-width: ".concat(MOBILE_SCREEN_WIDTH, "px)")] = {
                display: "block",
            },
            _b),
        deteleCta: {
            color: "#AA2822 !important",
        },
        reportCta: {
            color: "#FF0303 !important",
        },
        moreMenuItem: (_c = {
                cursor: "pointer",
                paddingRight: "12px",
                paddingLeft: "12px",
                display: "flex",
                alignItems: "center",
                fontSize: "14px"
            },
            _c["@media(max-width: ".concat(MOBILE_SCREEN_WIDTH, "px)")] = {
                paddingTop: "6px",
                paddingBottom: "6px",
            },
            _c),
    },
    componentName: "MoreButtonAndMenu",
});
var getThemedStyles = function (_a) {
    var theme = _a.theme;
    var color1 = getColorsFromCreatorTheme(theme).color1;
    return getStylesObjFromCss({
        styles: {
            editIcon: {
                color: color1 || "#493ab1",
            },
            votersCta: {
                color: "".concat(color1 || "#493ab1", " !important"),
            },
        },
        componentName: "MoreButtonAndMenu",
    });
};

export { getThemedStyles, styles };
//# sourceMappingURL=MoreButtonAndMenu.styles.js.map
